<app-pane title="Select Model">
  <button *ngFor="let model of models" (click)="modelSelected(model.key)">{{model.name}}</button>
</app-pane>
